module.exports = __webpack_public_path__ + "static/fake-news01-bef6215a14100c5df54d33d35c8a4c13.jpg";